var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "https://www.w3.org/2000/svg",
    width: 22,
    height: 22
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 1h20v20H1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 19.334A8.334 8.334 0 102.667 11 8.344 8.344 0 0011 19.334zM7.413 8.439a.724.724 0 111.025-1.025l2.434 2.434c.07.07.185.07.256 0l2.434-2.434a.727.727 0 01.705-.198.728.728 0 01.32 1.223l-2.434 2.434a.18.18 0 000 .256l2.434 2.434a.725.725 0 11-1.025 1.024l-2.435-2.434a.182.182 0 00-.256 0l-2.433 2.434a.724.724 0 01-1.025-1.024l2.434-2.434a.182.182 0 000-.256L7.413 8.439z",
    fill: "#D1E5FF"
  }))));
}
export default SvgCloseIcon;